import { useStickyDiff } from './useStickyDiff';
import { useError, useLoading } from '../api/hooks';
import { ActionType } from '../redux/actionType';
import { useToggle } from './useToggle';


/**
 * Use this to set a toggle that fires whenever the specified action returns with an error.
 *
 * @param actionType - the type of action to trigger the callback
 * @param requestId - the request Id (if any) of the specific action which should trigger the callback
 */
export const useToggleOnError = (
  actionType: ActionType,
  requestId: string | number | undefined = undefined,
): [boolean, () => void] => {
  const [value, setValue] = useToggle();
  const isLoading         = useLoading(actionType, requestId);
  const hasError          = !!useError(actionType, requestId);

  useStickyDiff(
    (prev, next) => {
      if (!!prev?.isLoading && !next.isLoading && next.hasError) {
        setValue();
      }
    },
    {
      isLoading: isLoading,
      hasError:  hasError,
    },
  );

  return [value, setValue];
};
